// Module: booking — «موعد جديد» (HANDOFF §3 `/booking/new`, §5.1) has no menu
// row: the entry is the top bar's neutral «موعد جديد» (+ the N shortcut), the
// gap «احجز هنا» rows and «موعد جديد له/لها» in a customer profile. Other
// modules open it through `@/features/booking/public`.
// The module also carries the appointments group's catalogue screens, after
// «اليوم» · «التقويم» (HANDOFF §3): «الخدمات والأسعار» (./services), «رابط
// الحجز وQR» (./page), «رسائل المراجعين» (./messages).

import { CalendarPlus } from 'lucide-react';
import { defineModule } from '@/app/module-types';
import { messagesMenu, messagesRoutes } from './messages';
import { pageMenu, pageRoutes } from './page';
import { servicesMenu, servicesRoutes } from './services';

export default defineModule({
  key: 'booking',
  label: 'المواعيد',
  icon: CalendarPlus,
  flag: 'erp.core',
  minRole: 'staff',
  rail: 'appointments',
  routes: [
    { path: '/booking/new', lazy: () => import('./screens/BookingRoute').then((m) => ({ Component: m.BookingRoute })) },
    ...servicesRoutes,
    ...pageRoutes,
    ...messagesRoutes,
  ],
  menu: [...servicesMenu, ...pageMenu, ...messagesMenu],
});
